var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfBigIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.6891 32.9029V87.6453C87.6891 92.7428 83.5569 96.875 78.4594 96.875H21.5408C16.4434 96.875 12.3112 92.7428 12.3112 87.6453V12.3547C12.311 7.25723 16.4432 3.125 21.5408 3.125H59.6635L87.6891 32.9029Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.689 32.9029H65.8166C62.4183 32.9029 59.6635 30.148 59.6635 26.7498V3.125L87.689 32.9029Z",
    fill: "#ED676A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9799 68.9621V75.1994H27.5514V56.824H34.8822C36.2883 56.824 37.5323 57.0824 38.6139 57.5992C39.6955 58.116 40.5307 58.855 41.1256 59.8105C41.7145 60.766 42.0149 61.8476 42.0149 63.0613C42.0149 64.8519 41.3719 66.2822 40.086 67.3578C38.8061 68.4273 37.0453 68.9621 34.8041 68.9621H31.9799ZM31.9799 65.5429H34.8822C35.7416 65.5429 36.3965 65.3326 36.8471 64.9C37.2977 64.4734 37.5201 63.8664 37.5201 63.0853C37.5201 62.2259 37.2858 61.541 36.8231 61.0242C36.3604 60.5134 35.7295 60.255 34.9303 60.2429H31.9799V65.5429Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3704 75.1994V56.824H50.2891C51.9116 56.824 53.3717 57.1906 54.6696 57.9296C55.9616 58.6626 56.977 59.7023 57.7042 61.0484C58.4313 62.3884 58.7977 63.8906 58.8038 65.555V66.4023C58.8038 68.0847 58.4493 69.5931 57.7401 70.9271C57.0311 72.2611 56.0276 73.3007 54.7356 74.0578C53.4436 74.8089 52.0014 75.1875 50.4151 75.1996H44.3704V75.1994ZM48.7991 60.2431V71.7923H50.3374C51.6112 71.7923 52.5846 71.3417 53.2637 70.4343C53.9487 69.533 54.2913 68.1871 54.2913 66.4023V65.6091C54.2913 63.8304 53.9487 62.4964 53.2637 61.5951C52.5846 60.6937 51.5932 60.2431 50.2893 60.2431H48.7991Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6547 67.8804H65.5099V75.1994H61.0814V56.824H73.3697V60.2431H65.5099V64.4734H72.6547V67.8804Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfBigIcon);
export default __webpack_public_path__ + "static/media/pdf-big-icon.080050abc1b745bba01ebfc87dda7cb7.svg";
export { ForwardRef as ReactComponent };